import React from 'react';
import { FormikValues } from 'formik';

import { useFormContext } from '@lyearn/form/src/Form/context/FormContext';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { MultiStep } from '@/components/MultiStep';

import MultiStepContent from '../MultiStepContent';
import MultiStepSidebar from '../MultiStepSidebar';
import MultiStepTabs from '../MultiStepTabs';
import { MultiStepFormProps } from '../types';

interface MultiStepContainerProps<TFormValues extends FormikValues> {
  inViewStep: string;
  setStep: (step: string) => void;
  disabledSections: MultiStepFormProps<TFormValues>['disabledSections'];
  sections: MultiStepFormProps<TFormValues>['sections'];
  onNext: (() => void) | undefined;
  onPrevious: (() => void) | undefined;
  variant: 'sidebar' | 'tabs';
}

function MultiStepContainer<TFormValues extends FormikValues>(
  props: MultiStepContainerProps<TFormValues>,
) {
  const { inViewStep, setStep, disabledSections, sections, onNext, onPrevious, variant } = props;
  const { overrides } = useFormContext();

  return (
    <MultiStep activeStepId={inViewStep} setStep={setStep}>
      {variant === 'sidebar' ? (
        <Stack className="h-full w-full overflow-auto">
          <MultiStepSidebar disabledSections={disabledSections} sections={sections} />
          <MultiStepContent sections={sections} onNext={onNext} onPrevious={onPrevious} />
        </Stack>
      ) : null}
      {variant === 'tabs' ? (
        <Stack className="h-full w-full overflow-auto" direction="col">
          <MultiStepTabs
            className={cn('shrink-0', overrides?.MultiStepTabs?.className)}
            disabledSections={disabledSections}
            sections={sections}
          />
          <MultiStepContent sections={sections} onNext={onNext} onPrevious={onPrevious} />
        </Stack>
      ) : null}
    </MultiStep>
  );
}

export default MultiStepContainer;
